import type { SelectOption } from './MobileSelect';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@skin-seoul/design-system';

interface DesktopSelectProps {
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  title?: string;
  width?: string | number;
  showSelectedValue?: boolean;
}

export const DesktopSelect = ({
  options,
  value,
  onChange,
  title = 'Sort',
  width,
  showSelectedValue = false,
}: DesktopSelectProps) => {
  const selectedOption = options.find((option) => option.value === value);

  return (
    <div
      style={{
        ...(width ? { width: typeof width === 'number' ? `${width}px` : width } : {}),
      }}
    >
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger className="h-9 min-h-9 bg-white text-neutral-700 rounded-lg border-neutral-100 border text-paragraph-small cursor-pointer whitespace-nowrap hover:bg-neutral-50">
          <SelectValue placeholder={title}>
            {showSelectedValue && selectedOption ? selectedOption.label : title}
          </SelectValue>
        </SelectTrigger>
        <SelectContent
          position="popper"
          sideOffset={4}
          className="rounded-lg shadow-[0_4px_16px_rgba(0,0,0,0.08)] border-neutral-200 p-2 max-h-[300px] min-w-[max(var(--radix-select-trigger-width),240px)]"
          style={{ zIndex: 2001 }}
        >
          {options.map((option, idx) => (
            <SelectItem
              key={option.value}
              value={option.value}
              className={`px-3 py-4 text-paragraph-small text-neutral-500 cursor-pointer rounded-none hover:bg-neutral-50 data-[state=checked]:bg-white data-[state=checked]:text-primary-500 [&>span:last-child]:hidden ${
                idx < options.length - 1 ? 'border-b border-neutral-100' : ''
              }`}
            >
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default DesktopSelect;
